import { z } from "zod";

/**
 * AtividadeObraSchema
 */

export const AtividadeObraSchema = z.object({
  atividade: z.string().nonempty({ message: 'Este campo deve ser preenchido!' }),
  idFuncionarioResponsavel: z.coerce.number().nullable().default(null),
  funcionarioResponsavel: z.string().nullable().default(null),
  preencherResponsavel: z.coerce.boolean().default(false),
  idFuncionarioCorresponsavel: z.coerce.number().nullable().default(null),
  funcionarioCorresponsavel: z.string().nullable().default(null),
  preencherCorresponsavel: z.coerce.boolean().default(false),
});

/**
 * AtividadeObraForm
 */

export type AtividadeObraForm = z.infer<typeof AtividadeObraSchema>;